// Customer-facing labels only. Staff labels and database statuses stay unchanged.
export const DOCUMENT_STATUSES = {
  'awaiting-save': { label: 'รอบันทึก', color: 'gray' },
  pending: { label: 'รอดำเนินการ', color: 'gray' },
  processing: { label: 'กำลังดำเนินการ (เปิดบิลแล้ว)', color: 'blue' },
  'awaiting-payment': { label: 'รอชำระเงิน', color: 'orange' },
  paid: { label: 'ชำระเงินแล้ว', color: 'green' },
  refunded: { label: 'คืนเงินแล้ว', color: 'green' },
  cancelled: { label: 'ยกเลิกแล้ว', color: 'red' }
};

export function sanitizeDocumentStatus(value) {
  return typeof value === 'string' && Object.prototype.hasOwnProperty.call(DOCUMENT_STATUSES, value) ? value : null;
}

function amount(value) {
  if (typeof value !== 'number' && (typeof value !== 'string' || !value.trim())) return null;
  const number = Number(value);
  return Number.isFinite(number) && number >= 0 ? Math.round(number * 100) : null;
}

// Based on _model.py document_status_dict, MenuShipDocument.vue and
// document.py pay_document/create_receipt_from_payment/done_debit_credit_note.
// IDs and payment records are used locally; only the resulting code is sent.
export function resolveDocumentStatus({ documentId, docType, status, payment, netPrice }) {
  if (!String(documentId || '').trim()) return 'awaiting-save';
  if (['quotation', 'invoice', 'receipt', 'debit-note', 'credit-note'].indexOf(docType) === -1) return null;
  // Do not coerce missing/null/blank values to the real pending status (0).
  if ([0, 1, 2, '0', '1', '2'].indexOf(status) === -1) return null;
  if (Number(status) === 2) return 'cancelled';
  if (Number(status) === 0) {
    return docType === 'quotation' || docType === 'debit-note' ? 'pending' : 'awaiting-payment';
  }
  // These source documents can be closed by either a full payment OR by
  // creation of unpaid invoices. Their status never proves full payment.
  if (docType === 'quotation' || docType === 'invoice') return 'processing';
  if (docType === 'debit-note') return 'refunded';
  const paid = amount(payment && payment.amount);
  const due = amount(netPrice);
  // Credit-note completion can record only the first installment. A receipt
  // represents its own paid portion, not the balance of its linked quotation.
  // Check persisted amounts, never the live, unsaved form's computed total.
  if (paid !== null && due !== null) return paid >= due ? 'paid' : 'awaiting-payment';
  // Incomplete legacy payment data cannot safely prove full collection.
  return null;
}
